var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forgotpassword"},[_c('ForgotPasswordThanksPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }